import { useEffect } from "react";

const Cosmetics = () => {
  useEffect(() => {
    document.title = "Cosmetics - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/cosmetics.jpg)` }}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Cosmetics</h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-9 m-auto">
              <h2>Cosmetics Rooted in Nature – Deww Botanicals</h2>

              <p>
                At Deww Botanicals, we harness the transformative power of
                natural oils and plant butters to create clean, effective, and
                skin-loving cosmetic products. Rooted in purity and inspired by
                Ayurvedic principles, our ingredients offer more than just
                beauty; they provide wellness, nourishment, and long-term care.
              </p>

              <img
                src="https://source.unsplash.com/800x400/?natural-cosmetics,ayurveda"
                alt="Natural cosmetic products"
              />

              <h2>Carrier Oils: The Nourishing Base</h2>

              <p>
                Our cold-pressed, nutrient-rich carrier oils serve as the
                foundation of many skincare and haircare formulations. They are
                used in:
              </p>
              <ul>
                <li>
                  Moisturizers and serums for deep hydration and barrier repair
                </li>
                <li>
                  Hair oils and masks to restore shine and strengthen roots
                </li>
                <li>Massage blends that rejuvenate skin and relax muscles</li>
              </ul>

              <p>
                Some of our favorites include jojoba, almond, coconut, and argan
                oils, all rich in vitamins and essential fatty acids that
                support natural skin health.
              </p>

              <img
                src="https://source.unsplash.com/800x400/?carrier-oils,jojoba"
                alt="Carrier oils - jojoba, almond, coconut"
              />

              <h2>Essential Oils: Nature’s Fragrant Therapy</h2>

              <p>
                We offer 100% pure, steam-distilled essential oils that provide
                therapeutic benefits for both skin and senses. You’ll find them
                in:
              </p>
              <ul>
                <li>
                  Face cleansers and toners for their antibacterial and
                  clarifying properties
                </li>
                <li>
                  Aromatherapy rollers and balms to elevate mood and calm the
                  mind
                </li>
                <li>
                  Shampoos and scalp oils to boost circulation and promote hair
                  growth
                </li>
              </ul>

              <p>
                From soothing lavender to purifying tea tree and energizing
                peppermint, each essential oil is chosen with intention and
                care.
              </p>

              <img
                src="https://source.unsplash.com/800x400/?essential-oils,lavender"
                alt="Essential oils - lavender, tea tree, peppermint"
              />

              <h2>Plant Butters: Deep Nourishment from Nature</h2>

              <p>
                Our rich, velvety plant butters deliver intensive hydration and
                skin protection for your beauty rituals. Key benefits include:
              </p>
              <ul>
                <li>
                  <strong>Shea butter</strong>, which softens and heals dry,
                  irritated skin
                </li>
                <li>
                  <strong>Cocoa butter</strong>, which smooths and firms the
                  skin, reducing the appearance of stretch marks
                </li>
                <li>
                  <strong>Mango butter</strong>, which adds a lightweight,
                  non-greasy layer of moisture
                </li>
              </ul>

              <p>
                These natural emollients are perfect for lip balms, body
                butters, and rich face creams, helping to protect the skin
                barrier while delivering essential nutrients.
              </p>

              <img
                src="https://source.unsplash.com/800x400/?shea-butter,plant-butter"
                alt="Shea and cocoa butter for skincare"
              />

              <h2>Clean Beauty, Backed by Nature</h2>

              <p>
                At Deww Botanicals, we say no to harsh chemicals, parabens,
                silicones, and synthetic fragrances. Instead, we formulate with
                ingredients your skin recognizes and loves—derived from nature
                and supported by centuries of Ayurvedic wisdom.
              </p>

              <img
                src="https://source.unsplash.com/800x400/?clean-beauty,natural-skincare"
                alt="Clean beauty products"
              />

              <h2>Why Choose Deww Botanicals Oils &amp; Butters?</h2>

              <ul>
                <li>Pure, cold-pressed, and unrefined</li>
                <li>Skin-safe and ethically sourced</li>
                <li>
                  Rich in vitamins, antioxidants, and essential fatty acids
                </li>
                <li>Tested for quality and formulated with precision</li>
              </ul>

              <h2>Elevate Your Everyday Rituals</h2>

              <p>
                Discover the beauty of natural oils and butters—only at Deww
                Botanicals, where every ingredient tells a story of care,
                purity, and performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cosmetics;
